export default __webpack_public_path__ + "static/media/icon_scooter_available_active.e5879a4b.png";